import React from 'react'
import {useNavigate, Routes, Route, Router} from '@startlibs/components'
import {PageLoadingSuspense} from '../components/PageLoading'
import {useNotification} from '../components/Notifications'
import {getJwt} from '../hooks/useJwt'
import {ExpertList} from './experts/ExpertList'
import {EditExpert} from './experts/EditExpert'
import {ViewExpert} from './experts/ViewExpert'
import {jwtGetFetcher, jwtPostFetcher} from '../utils/authFetch'

export const AdminExpertsRoutes = () => {
  const navigate = useNavigate()
  const [,setNotification] = useNotification()

  const addOrUpdateExpert = (newExpert) => (
    newExpert.id
      ? jwtPostFetcher(getJwt())('/api/expert', newExpert, {method: 'PUT'})
      : jwtPostFetcher(getJwt())('/api/expert', newExpert)
  )
    .then((expert) =>
      jwtGetFetcher(getJwt())(`/api/experts?nocache=${new Date().getTime()}`)
        .then(() =>  setNotification(newExpert.id ? "Expert profile updated successfully." : "Expert added successfully."))
        .then(() => expert)
    )


  return <PageLoadingSuspense>
    
    <Router>
      <Routes>
        <Route path="/admin/experts/edit/:id" element={<EditExpert action={addOrUpdateExpert}/>}/>
        <Route path="/admin/experts/new" element={<EditExpert action={addOrUpdateExpert} onSuccess={(values,{id}) => navigate("/admin/experts/view/"+id)} />}/>
        <Route path="/admin/experts/view/:id" element={<ViewExpert />}/>
        <Route path="/admin/experts*" element={<ExpertList />}/>
        <Route path="/admin/experts/*" element={<ExpertList />}/>
      </Routes>
    </Router>
    
  </PageLoadingSuspense>
}
